import { Controller } from "@hotwired/stimulus"

// Thin bar at the top of the window that fills as the content is read
export default class extends Controller {
  static targets = ["bar", "content"]

  connect() {
    this.update = () => {
      const { top, height } = this.contentTarget.getBoundingClientRect()
      const progress = Math.min(1, Math.max(0, -top / (height - innerHeight)))
      this.barTarget.style.setProperty("--progress", progress)
    }
    addEventListener("scroll", this.update, { passive: true })
    addEventListener("resize", this.update)
    this.update()
  }

  disconnect() {
    removeEventListener("scroll", this.update)
    removeEventListener("resize", this.update)
  }
}
